import React from 'react';

const LoginRequiredModal = ({
  title = 'Login Required',
  onCancel,
  children
}) => {
  return (
    <div className="modal" style={{ zIndex: 1000 }} onClick={onCancel}>
      <div className="login-modal-content" onClick={e => e.stopPropagation()}>
        <button
          className="modal-close-x"
          aria-label="Close"
          onClick={onCancel}
          type="button"
        >
          ×
        </button>
        <h2>{title}</h2>
        <div style={{ margin: '24px 0' }}>
          {children}
        </div>
      </div>
    </div>
  );
};

export default LoginRequiredModal; 